import { Component } from '@angular/core';

@Component({
  selector: 'wl-no-access',
  templateUrl: 'no-access.component.html',
    standalone: false
})
export class NoAccessComponent {
  public constructor() {}
}
